/*
* нигде не исп
* */

class ScrollTo {
    constructor(el) {
        this.btn = el
        //this._addEvents();
        //this._checkHash();
    }

    _addEvents(){
        var self = this;

        this.btn.onclick = function(e){
            var hash = this.hash,
                uid = hash.replace('#', ''),
                target = document.querySelector('[data-ScrollTo-id="'+ uid +'"]');

            //
            if(target){
                e.preventDefault();

                var top = target.getBoundingClientRect().top - APP.vars.topPadding,
                    duration = 300,
                    offset = window.pageYOffset,
                    left = window.pageXOffset;

                self.animate({
                    duration: duration,
                    timing: function(timeFraction) {
                        return timeFraction;
                    },
                    draw: function(progress) {
                        window.scrollTo(left, offset + progress * top);
                    }
                });
                location.hash = hash;
            }
        }
    }

    _checkHash(){
        var uid, target;

        //
        if(location.hash === this.btn.hash){
            uid = location.hash.replace('#', '');
            target = document.querySelector('[data-ScrollTo-id="'+ uid +'"]');

            if(target){
                var top = target.getBoundingClientRect().top - APP.vars.topPadding;
                scrollBy(0, top);
            }
        }
    }

    animate(options) {

        var start = performance.now();

        requestAnimationFrame(function animate(time) {
            // timeFraction от 0 до 1
            var timeFraction = (time - start) / options.duration;
            if (timeFraction > 1) timeFraction = 1;

            // текущее состояние анимации
            var progress = options.timing(timeFraction)

            options.draw(progress);

            if (timeFraction < 1) {
                requestAnimationFrame(animate);
            }
            else if(options.complete) options.complete();
        });
    }
}

export {ScrollTo};




































